import type { MouseEvent } from "react"
import { Link } from "react-router"
import type { Server } from "@mc/types"
import { useToast } from "../ui/Toast.js"

/**
 * No muestra un StatusDot (FR section 14): el DTO `Server` (GET
 * /api/v1/servers) no trae estado de ciclo de vida, solo datos
 * descriptivos. El estado en vivo llega via WebSocket/polling contra un
 * endpoint que todavia no existe (ver AGENT.md, ServerOverviewPage). Se
 * prefirio omitirlo antes que inventar un punto de color sin dato real
 * detras.
 */
export function ServerCard({ server }: { server: Server }) {
  const toast = useToast()

  const copyIp = async (event: MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    if (!server.publicIp) return
    await navigator.clipboard.writeText(server.publicIp)
    toast.show("IP copiada al portapapeles.", "success")
  }

  return (
    <Link
      to={`/servers/${server.serverId}`}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-2)",
        padding: "var(--space-4)",
        borderRadius: "var(--radius-md)",
        border: "1px solid var(--border-default)",
        background: "var(--bg-surface)",
        textDecoration: "none",
        color: "inherit",
        transition: `border-color var(--duration-small) var(--ease-out), transform var(--duration-micro) var(--ease-out)`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "var(--brand-primary)"
        e.currentTarget.style.transform = "translateY(-2px)"
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "var(--border-default)"
        e.currentTarget.style.transform = "translateY(0)"
      }}
    >
      <strong style={{ fontSize: "var(--text-lg)" }}>{server.name}</strong>
      <p style={{ fontSize: "var(--text-sm)", color: "var(--text-muted)", minHeight: "1.4em" }}>
        {server.description ?? "Sin descripción."}
      </p>
      {server.publicIp && (
        <button
          onClick={copyIp}
          style={{
            alignSelf: "flex-start",
            display: "flex",
            alignItems: "center",
            gap: "var(--space-2)",
            fontSize: "var(--text-xs)",
            color: "var(--text-muted)",
            background: "var(--bg-hover)",
            border: "1px solid var(--border-default)",
            borderRadius: "var(--radius-sm)",
            padding: "4px var(--space-2)",
            transition: "color var(--duration-small) var(--ease-out)",
          }}
        >
          {server.publicIp} · copiar
        </button>
      )}
    </Link>
  )
}
